module.exports = __webpack_public_path__ + "img/kachel_aloevia_BODYCARE.224f6b10.png";